import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Spinner from "../../Components/Spinner";
import { useLanguage } from "../../Translations/LenguageContext";
import ErrorMessage from "../../Components/ErrorMessage";

const TicketModal = ({ show, handleClose, recordObject, fetchRecords  }) => {
    const { t } = useLanguage()
    const user_id = sessionStorage.getItem("user_id")
    const [error, setError] = useState({ message: "", display: false });
    const [inputValue, setInputValue] = useState("");
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [loadingDel, setLoadingDel] = useState(false)
    const [recordId, setRecordId] = useState("");
    const [orgName] = useState("Delete");

    useEffect(() => {
        if (recordObject) {
            setRecordId(recordObject._id || "");
        }
    }, [recordObject]);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);

        if (value != "") {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
    };

    const handleCloseModal = () => {
        setRecordId("")
        setIsButtonDisabled(true);
        handleClose()
        setError({ message: "", display: false })
        setInputValue("")
    }

    const deleteOrganization = async () => {
        try {
            setLoadingDel(true)
            const response = await fetch(`https://backend.erioon.com/close_ticket`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id: user_id, ticket_id: recordId, resolution_summary: inputValue }),
            });
            setLoadingDel(false)
            if (response.ok) {
                handleCloseModal()
                fetchRecords()
            } else {
                setError({ message: t.err_delete_general, display: true })
            }
        } catch (err) {
            setLoadingDel(false)
            setError({ message: t.err_delete_general, display: true })
        }
    };

    return (
        <Modal show={show} onHide={handleCloseModal} className="modal_delete">
            <div className="modal_header">
                <p>Are you sure you want to close this ticket?</p>
                <i className="fa-solid fa-x" onClick={handleCloseModal}></i>
            </div>
            <div className="modal_body">
                <p className="warning_delete_message">This action CANNOT be undone. It will permanently close the ticket.</p>
                <div className="delete_action_cont">
                    <p className="type_phrase_delete">To confirm, please enter the solution summary</p>
                    <textarea
                        style={{height: "100px"}}
                        className="delete_input"
                        placeholder="The issue was solved becouse..."
                        value={inputValue}
                        onChange={handleInputChange}
                    />
                </div>
            </div>
            <div className="modal_footer">
                <ErrorMessage err={error} />
                <div className="footer_btn_cont">
                     <button
                        className={`delete_btn ${isButtonDisabled ? "" : "delete_btn_active"}`}
                        onClick={deleteOrganization}
                        disabled={isButtonDisabled}
                    >
                        {loadingDel ? (
                            <Spinner loading={loadingDel} />
                        ) : (
                            <>Close ticket</>
                        )}
                    </button>
                    <button className="cancel_btn" onClick={handleCloseModal}>{t.cancel}</button>
                </div>
            </div>
        </Modal>
    );
};

export default TicketModal;
